import { getHashObj } from '../components/getSubjectId';
import * as pdfjsLib from 'pdfjs-dist';

export const convertPdfToPng = async (file: File): Promise<{file: File, pageCount: number}> => {
    const arrayBuffer = await file.arrayBuffer();
    const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;

    const pageCanvases: HTMLCanvasElement[] = [];
    const scale = 2.0;

    for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
        const page = await pdf.getPage(pageNum);
        const viewport = page.getViewport({ scale });

        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        if (!context) {
            throw new Error('Canvas context not available');
        }

        canvas.width = viewport.width;
        canvas.height = viewport.height;

        await page.render({
            canvasContext: context,
            viewport: viewport,
            canvas: canvas
        } as any).promise;

        pageCanvases.push(canvas);
    }

    if (pageCanvases.length === 0) {
        throw new Error('No pages to convert');
    }

    const maxWidth = pageCanvases.reduce((max, canvas) => Math.max(max, canvas.width), 0);
    const totalHeight = pageCanvases.reduce((sum, canvas) => sum + canvas.height, 0);

    const combinedCanvas = document.createElement('canvas');
    const combinedContext = combinedCanvas.getContext('2d');
    if (!combinedContext) {
        throw new Error('Combined canvas context not available');
    }

    combinedCanvas.width = maxWidth;
    combinedCanvas.height = totalHeight;

    combinedContext.fillStyle = '#ffffff';
    combinedContext.fillRect(0, 0, maxWidth, totalHeight);

    let currentY = 0;
    pageCanvases.forEach(canvas => {
        combinedContext.drawImage(canvas, 0, currentY);
        currentY += canvas.height;
    });

    const blob = await new Promise<Blob>((resolve, reject) => {
        combinedCanvas.toBlob((result) => {
            if (result) {
                resolve(result);
            } else {
                reject(new Error('Failed to create PNG blob'));
            }
        }, 'image/png');
    });

    pageCanvases.forEach(canvas => {
        canvas.width = 0;
        canvas.height = 0;
    });
    combinedCanvas.width = 0;
    combinedCanvas.height = 0;

    const pngName = file.name.replace(/\.pdf$/i, '.png');
    return {
        file: new File([blob], pngName, { type: 'image/png' }),
        pageCount: pdf.numPages
    };
};

export const getBiomarkerFields = (values?: any) => {
    try {
        let indicArr = JSON.parse(localStorage.getItem('indicator_values') || '') || [];
        return indicArr.map((it: any) => {
            return { indicatorId: it[0], value: it[1] }
        })
    } catch (e) {
        return []
    }
}

export const getDefatultIndicatorValues = () => {
    try {
        let hashObj: object | null = getHashObj();
        if (Object.keys(hashObj).filter(it => it).length == 0) {
            hashObj = null;
        }
        let obj = hashObj || JSON.parse(localStorage.getItem("_values") || '') || {};
        return obj
    } catch (e) {
        return {}
    }
}

// Функции для сохранения и восстановления состояния анализов
export const saveAnalysisState = (state: any) => {
    try {
        localStorage.setItem('analysis_state', JSON.stringify(state));
        console.log('✅ Analysis state saved successfully:', state);
        console.log('📦 Saved to localStorage:', localStorage.getItem('analysis_state'));
    } catch (e) {
        console.error('❌ Failed to save analysis state:', e);
    }
};

export const loadAnalysisState = () => {
    try {
        const saved = localStorage.getItem('analysis_state');
        // console.log('🔍 Loading analysis state from localStorage:', saved);
        const parsed = saved ? JSON.parse(saved) : null;
        // console.log('📖 Parsed analysis state:', parsed);
        return parsed;
    } catch (e) {
        console.error('❌ Failed to load analysis state:', e);
        return null;
    }
};

export const clearAnalysisState = () => {
    try {
        localStorage.removeItem('analysis_state');
    } catch (e) {
        console.error('Failed to clear analysis state:', e);
    }
};

export const saveTableValuesToStorage = (fields: any[], values: any) => {
    try {
        const tableValues = {
            fields: fields,
            values: values,
            timestamp: Date.now()
        };
        localStorage.setItem('table_values', JSON.stringify(tableValues));
        console.log('✅ Table values saved successfully');
    } catch (e) {
        console.error('❌ Failed to save table values:', e);
    }
};

export const loadTableValuesFromStorage = () => {
    try {
        const saved = localStorage.getItem('table_values');
        if (saved) {
            const parsed = JSON.parse(saved);
            console.log('📖 Loaded table values from localStorage:', parsed);
            return parsed;
        }
        return null;
    } catch (e) {
        console.error('❌ Failed to load table values:', e);
        return null;
    }
};

export const clearTableValues = () => {
    try {
        localStorage.removeItem('table_values');
    } catch (e) {
        console.error('Failed to clear table values:', e);
    }
};

export const initHash = (_fields: any, navigate?: any, values?: any) => {
    let _values = { ...values || {} }
    let __fields = _fields
    let str = __fields
        .filter((it: any) => it.indicatorId && it.value)
        .map((it: any) => {
            let { indicatorId, value } = it
            let _vv = _values[indicatorId]
            delete _values[indicatorId]
            return `${indicatorId}=${_vv || ''}`
        })
        .join('&')

    let valuesStr = Object.keys(_values).map(key => {
        return _values[key] && _values[key] != '' && _values[key] != 'undefined' ? `${key}=${_values[key]}` : ''
    }).filter(it => it).join('&')
    if (valuesStr) {
        str += '&' + valuesStr;
    }

    function getFields() {
        let arr: any[] = []
        __fields.forEach((it: any) => {
            if (it.indicatorId || it.value) {
                arr.push([it.indicatorId, it.value])
            }
        })
        return arr
    }

    localStorage.setItem('indicator_values', JSON.stringify(getFields()))
    localStorage.setItem('_values', JSON.stringify(values))
    if (navigate) {
        navigate(window.location.pathname + '?' + str, { replace: 'true' })
    }
    return str
}

export const toObj = (arr: any[]) => {
    console.log('qqqqq arrrrrrr', arr)
    return (arr || []).reduce((acc, it) => {
        return { ...acc, [it._id]: it }
    }, {})
}

let __timer: any = {};

export const debounceWrapper = (fn: any, DEBOUNCE_INIT_HASH_MS: number, key: string) => {
    clearTimeout(__timer[key]);
    __timer[key] = setTimeout(() => {
        fn && fn()
    }, DEBOUNCE_INIT_HASH_MS)
}

export function getDecoded(nValue: any) {
    let decodedValue = '---'
    console.log("qqqqq nvalue", nValue);
    try {
        decodedValue = decodeURIComponent(nValue)
    } catch (e) {
        console.log("qqqqq error", e);
    }
    return decodedValue
}

export const biomarkerNameMatches = (optionValue: string, serverName: string): boolean => {
    const a = optionValue.toLowerCase().trim();
    const b = serverName.toLowerCase().trim();
    if (a === b) return true;
    const stripParens = (s: string) => s.replace(/\s*\([^)]*\)/g, '').trim();
    const aStripped = stripParens(a);
    const bStripped = stripParens(b);
    if (aStripped === bStripped) return true;
    if ((aStripped.includes(' ') || bStripped.includes(' ')) && aStripped && bStripped) {
        if (aStripped.includes(bStripped) || bStripped.includes(aStripped)) return true;
    }
    const getParens = (s: string) => {
        const match = s.match(/\(([^)]+)\)/);
        return match ? match[1].toLowerCase().trim() : '';
    };
    const aInParens = getParens(a);
    const bInParens = getParens(b);
    if (aInParens && bInParens && aInParens === bInParens) return true;
    if (aStripped && bInParens && aStripped === bInParens) return true;
    if (bStripped && aInParens && bStripped === aInParens) return true;
    return false;
};

export const biomarkerOptionMatches = (opt: { value: string; aliases?: string[] }, serverName: string): boolean => {
    if (biomarkerNameMatches(opt.value, serverName)) return true;
    if (opt.aliases) {
        return opt.aliases.some(alias => alias.toLowerCase().trim() === serverName.toLowerCase().trim());
    }
    return false;
};

export const translateBiomarkerName = (name: string, userBiomarkerOptions: any[]): string => {
    const match = userBiomarkerOptions.find(opt => biomarkerOptionMatches(opt, name));
    return match ? match.label : name;
};

export const getMissingBiomarkerFields = (serverBiomarkers: any[], userBiomarkerOptions: any[]) => {
    const missingOptions = userBiomarkerOptions.filter(opt =>
        !serverBiomarkers.some((bm: any) => biomarkerOptionMatches(opt, bm.nameEn))
    );
    return missingOptions.map((opt, idx) => ({
        indicatorId: `missing_${Date.now()}_${idx}`,
        name: opt.value,
        value: '',
        unit: '',
        labReferenceRange: { min: '', max: '', unit: '', originalText: '' },
        userAdded: true,
    }));
};

export const generateUserBiomarkerObj = (field: any) => {
    return {
        "nameEn": field.name,
        "originalValue": field.value !== '' && field.value !== undefined ? Number(field.value) : null,
        "standardizedValue": field.value !== '' && field.value !== undefined ? Number(field.value) : null,
        "originalUnit": field.unit || "",
        "userAdded": true,
        "labReferenceRange": {
            "min": field.labReferenceRange?.min !== '' && field.labReferenceRange?.min !== undefined ? Number(field.labReferenceRange.min) : null,
            "max": field.labReferenceRange?.max !== '' && field.labReferenceRange?.max !== undefined ? Number(field.labReferenceRange.max) : null,
            "unit": field.unit || "",
            "originalText": ""
        }
    }
};

export const generateFileHash = async (file: File): Promise<string> => {
    const buffer = await file.arrayBuffer();
    const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
};